export default __webpack_public_path__ + "static/media/empty-bag.e4be10a0.svg";